import React, {useState} from 'react';
import {Portlet, PortletBody, PortletFooter, PortletHeader} from "../../../../components/Portlet";
import {Form, Modal} from "react-bootstrap";
import _ from "lodash"
import {Button} from "reactstrap";
import {useForm} from "react-hook-form";
import UsersBlock from "../../../trips/trip/components/tripFormParts/usersBlock";
import LoadingButton from "../../../base/components/loadingButton";
import axios from "../../../../helpers/axios";
import {noDispHeader} from "../../../../helpers/errorTranslate";
import sayError from "../../../../helpers/sayError";
import {useNavigate} from "react-router";
import {TripItemEditRoute, TripItemListRoute} from "../../../routesConstants";
import {Link} from "react-router-dom";

const CreateElements = ({airItems}) => {
  const startSelected = []
  airItems.forEach(i=>{
    if(i.ticketNumber && i.id && !!!i.tripItem){
      startSelected.push(i.id)
    }
  })
  console.log('airItems',airItems)
  const [selectedItems, setSelectedItems] = useState(startSelected)
  const [show, setShow] = useState(false)
  const formController = useForm()
  const [loading, setLoading] = useState(false)
  const [standartRender, setStandartRender] = useState(true)
  const navigate = useNavigate()

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = (data) =>{
    setLoading(true)
    const sendingData = {
      tickets : selectedItems,
      visibleToAccounts: data.item.visibleToAccounts.map(i=>i.userId)
    }
    axios.post('/api/trips/createTicketItems', sendingData, {headers: noDispHeader})
      .then(()=>{
        setStandartRender(false)
      })
      .catch(sayError)
      .finally(()=>setLoading(false))
    console.log('data', sendingData)
  }
  return (
    <>
      <Portlet>
        <PortletHeader title={'Элементы'}/>
        <PortletBody>
          {airItems.map((item,index)=>{
            if(item.id && item.ticketNumber ){
              return <div key={index}>
                {item.tripItem ?<Link to={TripItemEditRoute+item.tripItem} target={'_blank'}>
                    {item.airlineCode} - {item.ticketNumber} (уже в базе)
                </Link>:
                  <Form.Label className={'d-flex align-items-center gap-2'}>
                  <input
                    checked={selectedItems.includes(item.id)}
                    onChange={(e) => {
                      if (e.target.checked && !selectedItems.includes(item.id)) {
                        setSelectedItems(old => [...old, item.id])
                      } else if (!e.target.checked) {
                        setSelectedItems(old => _.filter(old, (i) => i !== item.id))
                      }
                    }}
                    type={"checkbox"}
                  />{item.airlineCode} - {item.ticketNumber}
                </Form.Label>}
              </div>
            }
          })}
        </PortletBody>
        <PortletFooter>
          <Button disabled={selectedItems.length < 1}
                  onClick={handleShow}>
            Создать элементы
          </Button>
        </PortletFooter>
      </Portlet>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Выберите к какому аккаунту привязать</Modal.Title>
        </Modal.Header>
        {standartRender ? <form onSubmit={formController.handleSubmit(onSubmit)}>
          <Modal.Body>
            <UsersBlock
              prefix={"item.visibleToAccounts"}
              formController={formController}
            />
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton loading={loading} onClick={formController.handleSubmit(onSubmit)} title={'Создать'}/>
          </Modal.Footer>
        </form>:
          <>
            <Modal.Body>
              <Button type={'button'} onClick={()=>{
                setStandartRender(true)
                formController.reset()
                setShow(false)
              }}>Остаться</Button>
              <Button type={'button'} onClick={()=>{
                navigate(TripItemListRoute+'#ticket')
              }}>Перейти на лист элементов</Button>
            </Modal.Body>
          </>

        }
      </Modal>

    </>
  );
};

export default CreateElements;
